import { AssetInformationModal, RadioTab, Space, TabStrip, Typography } from '@/components/core-v2'

import { useAppSelector } from '../../../store/hooks'
import { FundingSource } from '../../02-terms/state/terms-slice'
import { ModelPortfolioEditor } from '../model-portfolio'
import { SelfSelectPortfolioEditor } from '../self-select-portfolio'
import { PortfolioStepActions, PortfolioStepState } from '../state/portfolio-slice'

type PortfolioEditorProps = {
  actions: PortfolioStepActions
  state: PortfolioStepState
}

export const PortfolioEditor = ({ actions, state }: PortfolioEditorProps) => {
  const termsState = useAppSelector(state => state.terms)
  const { fundingSource } = termsState.terms
  if (fundingSource === FundingSource.Transfer && !state.portfolioType) {
    actions.setPortfolioTypeSelfSelect()
  }

  return (
    <>
      {fundingSource === FundingSource.Transfer && (
        <Space mb="5" mt="3">
          <Typography variant="b2">
            Build a self select portfolio using transferred units
          </Typography>
        </Space>
      )}
      {fundingSource !== FundingSource.Transfer && (
        <TabStrip>
          <RadioTab
            data-testid="tab-model"
            isSelected={state.portfolioType === 'ModelPortfolio'}
            onClick={() => actions.setPortfolioTypeModel()}
          >
            Model
          </RadioTab>
          <RadioTab
            data-testid="tab-fund-of-funds"
            isSelected={state.portfolioType === 'FundOfFunds'}
            onClick={() => actions.setPortfolioTypeFundOfFund()}
          >
            Fund of funds
          </RadioTab>
          <RadioTab
            data-testid="tab-self-select"
            isSelected={state.portfolioType === 'SelfSelect'}
            onClick={() => actions.setPortfolioTypeSelfSelect()}
          >
            Self select
          </RadioTab>
        </TabStrip>
      )}

      {(state.portfolioType === 'ModelPortfolio' || state.portfolioType === 'FundOfFunds') && (
        <ModelPortfolioEditor
          actions={actions}
          portfolioType={state.portfolioType}
          searchState={state.search}
          state={state.model}
        />
      )}

      {state.portfolioType === 'SelfSelect' && (
        <SelfSelectPortfolioEditor
          actions={actions}
          searchAssetState={state.searchAsset}
          searchPortfolioState={state.search}
          state={state.selfSelect}
        />
      )}
      <AssetInformationModal
        assetId={state.assetBeingInspected?.assetId}
        isOpen={state.isInspectingAsset}
        onClose={() => actions.stopInspectingAsset()}
      />
    </>
  )
}
